import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ConfirmationModal from '../ConfirmationModal';
import InfoPopup from '../InfoPopup';
import './APNDropdownSelect.css';

const disabledDropDownItemStyle = {
  backgroundColor: 'gray',
  opacity: '0.7',
  width: '100%',
};

const defaultStyle = { width: '100%' };

export function findSelectedOption(selectedOption, options) {
  const { value } = selectedOption || {};

  const flatOptions = options?.flatMap(option =>
    option.options ? option.options : [option]
  );

  if (!value) {
    return { label: 'Select any APN', value: '' };
  }

  return (
    flatOptions.find(option => option.value === value) || {}
  );
}

class APNDropdownSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedOption: findSelectedOption(props.selectedOption, props.options),
      separateOption: '',
      triggeredOption: '',
      warningModalText: '',
    };
  }

  componentDidUpdate = prevProps => {
    if (prevProps.selectedOption !== this.props.selectedOption) {
      this.setState({
        selectedOption: findSelectedOption(this.props.selectedOption, this.props.options),
      });
    }
    if (prevProps.selectionTrigger !== this.props.selectionTrigger) {
      const { onSelect, selectionTrigger, options } = this.props;
      const { triggeredOption } = this.state;
      if (selectionTrigger === 'cancel') {
        this.setState({
          selectedOption: options[0],
        });
        // onSelect(options[0]);
      } else if (selectionTrigger === 'confirm') {
        this.setState({
          selectedOption: { label: 'SuperAdmin', value: 'superAdmin' },
        });
        // onSelect(triggeredOption);
      }
    }
  };

  onClose = () => {
    this.setState(prev => ({ ...prev, warningModalText: '' }));
  };

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onOptionSelect = option => {
    const { onSelect, type, trgiggerText, warningText } = this.props;
    if (option.disabledItem) {
      const { label } = option;
      const WARNING_TEXT = `${label} ${warningText}` || `${label} not available at this time`;
      this.setState(prev => ({ ...prev, warningModalText: WARNING_TEXT }));
      return;
    }
    if (trgiggerText === option.value) {
      onSelect(option);
      this.setState({
        triggeredOption: option,
      });
    } else {
      if (type === 'user') {
        this.setState({ separateOption: option }, () => {
          onSelect(option);
        });
      } else {
        this.setState({
          selectedOption: option,
        });
        onSelect(option);
      }
    }
  };

  renderTypes = () => {
    const { options, disabled, groupedAPNDropdown } = this.props;
  
    const selectedOption = this.props.selectedOption
      ? findSelectedOption(this.props.selectedOption, this.props.options)
      : this.state.selectedOption;
  
    if (groupedAPNDropdown) {
      const customGroup = options.find(g => g.label === 'Custom');
      const grouped = options.filter(g => g.label !== 'Custom');
  
      return (
        <>
          {customGroup?.options?.map(option => (
            <DropdownItem
              key={option.value}
              disabled={disabled}
              className="apn-custom-item"
              onClick={() => this.onOptionSelect(option)}
            >
              {option.label}
            </DropdownItem>
          ))}
  
          {/* SAPN / PAPN groups */}
          {grouped.map(group => (
            <React.Fragment key={group.label}>
  
              {/* header */}
              <div className="apn-group-header">
                <div  style={{ fontWeight: 700, fontSize: 13, color: '#111' }}>
                  {group.label}
                </div>
                <div className="apn-divider" />
              </div>
  
              {/* options */}
              {group.options?.map(option =>
                option.value !== selectedOption.value ? (
                  <DropdownItem
                    key={option.value}
                    disabled={disabled}
                    onClick={() => this.onOptionSelect(option)}
                  >
                    {option.label}
                  </DropdownItem>
                ) : null
              )}
  
            </React.Fragment>
          ))}
        </>
      );
    }
  
    return options.map(option => (
      <DropdownItem
        key={option.value}
        disabled={disabled}
        onClick={() => this.onOptionSelect(option)}
      >
        {option.label}
      </DropdownItem>
    ));
  };

  render() {
    const { selectedOption, dropdownOpen, warningModalText } = this.state;
    const { disabled, customDropdownWidth, customBgColor, customDopdownClass } = this.props;
    return (
      <>
        <ConfirmationModal
          isOpen={!!warningModalText}
          bodyText={warningModalText}
          onCancel={this.onClose}
          ignoreConfirmButton
        />
        <Dropdown
          style={{ width: customDropdownWidth || '100%' }}
          direction="down"
          name="type"
          isOpen={dropdownOpen}
          toggle={this.toggle}
          className={`${customDopdownClass}`}
          id="dropdown-btn"
        >
          <DropdownToggle
            outline
            disabled={disabled}
            className={`dropdown-field`}
            style={{ width: '100%', minHeight: 'calc(1.5em + .75rem + 2px)', backgroundColor: customBgColor || 'transparent' }}
          >
            {this.props.selectedOption
              ? findSelectedOption(this.props.selectedOption, this.props.options).label
              : selectedOption.label}
          </DropdownToggle>
          <DropdownMenu style={{ width: '100%' }}>{this.renderTypes()}</DropdownMenu>
        </Dropdown>
      </>
    );
  }
}

APNDropdownSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  selectedOption: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func,
};

APNDropdownSelect.defaultProps = {
  options: [],
  onSelect: () => {},
};

export default APNDropdownSelect;
